import { useEffect, useState } from 'react';
import { BsArrowLeft } from 'react-icons/bs';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { getDiscountStorageValue } from 'src/components/discount-storage';
import ItemsModal from 'src/components/itemsModal';
import Order from 'src/components/order';
import { CurrencyAmount } from 'src/containers/currency';
import { addCurrentOrder, addCurrentOrderInfo } from 'src/redux/action/currentOrder.action';
import { RootState } from 'src/redux/reducers';
import Service from 'src/setup/network';
import { Variant } from 'src/types/model';

const Variants: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  useEffect(() => {
    if (!location.state) {
      navigate('/dine-in');
    }
  }, [location.state, navigate]);

  const item = location.state?.item;
  const type = location.state?.type;
  const isEditing = location.state.isEditing || false;
  const orderId = location.state?.orderId || null;
  const tableId = location.state?.tableId || null;
  const previousData = location.state?.previousData || null;
  const tableHasItem = location.state?.tableHasItem;
  const table = location.state?.table;
  const hasFetched = location.state?.hasFetched;
  const newTable = location?.state?.newTable;
  const currentItemCategory = location?.state?.currentItemCategory;

  const [showVariantsModal, setShowVariantsModal] = useState<boolean[]>([]);
  const { orderInfo } = useSelector(
      ({ currentOrderData }: RootState) => currentOrderData
    );
  const [discountInfo, setDiscountInfo] = useState<any>(
    getDiscountStorageValue(orderInfo)
  );

  useEffect(() => {
    const a: boolean[] = item?.variants?.map(() => false);
    setShowVariantsModal(a);
  }, []);

  const handleModalVariantsOpen = (index: number) => {
    if (showVariantsModal.includes(true)) {
      return;
    }
    const updatedModalStates = [...showVariantsModal];
    updatedModalStates[index] = true;
    setShowVariantsModal(updatedModalStates);
  };

  const handleModalVariantsClose = (index: number) => {
    const updatedModalStates = [...showVariantsModal];
    updatedModalStates[index] = false;
    setShowVariantsModal(updatedModalStates);
  };

  const fetchTableDataBackOffice = async () => {
    const userInfo = JSON.parse(
      window.localStorage.getItem('userInfo') || ''
    );
    try {
      const data = await Service.get(
        `/floors/tables/one/${location.state.table.id}/backOffice`
      );
      const dataOrders = data?.data?.tableOpenCheck?.orderInfo;

      const user = null;
      const a = {
        businessId: userInfo?.businessInfo?.id,
        type: 'dine_in',
        tableId: location.state?.table?.id,
        tableName: data?.data?.tableOpenCheck?.name,
        userId: user,
        origin: 'pos_device',
        promo: null,
        deliveryCharge: 0,
        dataOrders: dataOrders,
        items:
          dataOrders.items.length > 0
            ? dataOrders.items.map((item: any) => {
                return {
                  id: item.id,
                  itemId: item.itemId,
                  name: item.itemName,
                  variantId: item.variantId,
                  variantName: item.variantName,
                  hasVariants: item.hasVariants,
                  identifierId: item.id,
                  quantity: item.quantity,
                  decreaseLimit: item.decreaseLimit,
                  spiceLevel: item.spiceLevel || null,
                  selectedModifiers: item.allModifiers.map(
                    (modifier: any) => {
                      const optionsWithSelected = modifier.options.map(
                        (option: any) => {
                          const optionInModifiers = item.modifiers
                            .find((mod: any) => mod.id === modifier.id)
                            ?.options.find(
                              (op: any) => op.id === option.id
                            );
                          return {
                            id: option.id,
                            price: option.price,
                            name: option.name,
                            hasSelected: !!optionInModifiers,
                          };
                        }
                      );
                      return {
                        id: modifier.id,
                        name: modifier.name,
                        options: optionsWithSelected,
                      };
                    }
                  ),
                  price: item?.originalPrice,
                  priceAfterItemDiscount: item?.priceAfterItemDiscount,
                  note: item?.note || '',
                  discountAmount: item?.originalPrice - item?.priceAfterItemDiscount,
                  itemLevelDiscount: item.itemLevelDiscount
                };
              })
            : [],
      };
      if (dataOrders.items.length > 0) {
        dispatch(addCurrentOrder({ ...a }));
        dispatch(addCurrentOrderInfo(dataOrders));
      }
    } catch (err: any) {
    }
  };

  return (
    <>
      <div className="w-full h-[calc(100vh-75px)] text-black flex flex-row justify-between gap-4  ">
        <div className="w-full h-full flex flex-col gap-[18px]">
          <div className="h-[41px] text-black absolute -top-[68px]">
            <div
              className="flex flex-row gap-3 items-center cursor-pointer h-full"
              onClick={() => {
                // if (table) {
                navigate('/table', {
                  state: {
                    table: table,
                    type: type,
                    fetchTable: true,
                    hasFetched: hasFetched,
                    isEditing: isEditing,
                    orderId: orderId,
                    payment: false,
                    tableHasItem: tableHasItem,
                    tableId: tableId,
                    previousData: previousData,
                    newTable: newTable,
                    discountSend: discountInfo,
                    currentItemCategory,
                  },
                });
                // } else {
                //   navigate(-1);
                // }
              }}
            >
              <BsArrowLeft fontSize={20} />
              <div className="font-Outfit font-semibold text-[20px] leading-[32px]">
                {item?.name}
              </div>
            </div>
          </div>
          <div className="w-full xl:w-[730px] h-fit flex flex-row flex-wrap gap-3 cursor-pointer">
            {item?.variants?.map((variant: Variant, ind: number) => {
              return (
                <div
                  key={ind}
                  className="w-[300px] xl:w-[358px] h-[48px]  border border-[#CACFE3] rounded-xl flex justify-between items-center px-4"
                  onClick={() => {
                    handleModalVariantsOpen(ind);
                  }}
                >
                  <div className="font-Outfit font-semibold text-base text-[#2B2B2B] ">
                    {variant?.name}
                  </div>

                  {item.discount ? (
                    <>
                      {' '}
                      <div className="font-Outfit flex gap-2 font-semibold text-base text-[#949CC0]">
                        <div style={{ textDecoration: 'line-through' }}>
                          <CurrencyAmount amount={variant?.price}/>
                        </div>{' '}
                        <CurrencyAmount amount={variant?.discountedPrice}/>
                      </div>
                    </>
                  ) : (
                    <div className="font-Outfit font-semibold text-base text-[#949CC0]">
                      <CurrencyAmount amount={variant?.discountedPrice}/>
                    </div>
                  )}
                  {showVariantsModal[ind] && (
                    <ItemsModal
                      handleClose={() => {
                        handleModalVariantsClose(ind);
                      }}
                      items={item}
                      item={variant}
                      showModal={showVariantsModal[ind]}
                      type={type}
                      tableId={tableId}
                      tableName={location.state?.table?.name ?? ''}
                      fetchTableDataBackOffice={fetchTableDataBackOffice}
                    />
                  )}
                </div>
              );
            })}
          </div>
        </div>
        <Order
          isEditing={isEditing}
          orderId={orderId}
          payment={false}
          tableHasItem={tableHasItem}
          tableId={tableId}
          previousData={previousData}
          discountInfo={discountInfo}
          setDiscountInfo={setDiscountInfo}
        />
      </div>
    </>
  );
};

export default Variants;
